import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import NavBar from "./components/NavBar";
import LandingPage from "./components/LandingPage";
import Footer from "./components/Footer";
import Reports from "./components/Reports";
import Terms from "./components/Terms";
import ErrorPage from "./components/ErrorPage";
import DocumentsModal from "./components/ui-elements/DocumentsModal";
import { LanguageProvider } from "./context/LanguageContext";

const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

export default function App() {
  useScrollToTop();

  const [isDocumentsModalOpen, setIsDocumentsModalOpen] = useState(false);
  const [documentsInitialTab, setDocumentsInitialTab] = useState("reports");

  const handleOpenDocuments = (tab = "reports") => {
    setDocumentsInitialTab(tab);
    setIsDocumentsModalOpen(true);
  };

  return (
    <LanguageProvider>
      <div className="overflow-x-hidden min-h-screen flex flex-col bg-white text-slate-800 antialiased selection:bg-brandRed selection:text-white">
        {/* Transparency Documents & Terms Modal */}
        <DocumentsModal
          isOpen={isDocumentsModalOpen}
          onClose={() => setIsDocumentsModalOpen(false)}
          initialTab={documentsInitialTab}
        />

        {/* Sticky Glassmorphic Navbar */}
        <NavBar />

        {/* Main Single Page Content */}
        <main className="flex-grow flex flex-col p-0">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer onOpenDocuments={handleOpenDocuments} />
      </div>
    </LanguageProvider>
  );
}
